import React, { useState } from 'react';
import { navigate, RouteComponentProps } from '@reach/router';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormTextField from 'components/formComponents/FormTextField';
import { PostForgottenPassword } from './forgottenPasswordApi';
import { ForgottenPasswordPost } from './models';
import { Spinner } from 'components/spinner/Spinner';
import ConfirmationBox from 'components/confirmationBox/ConfirmationBox';
import { AppPath } from 'appConstants';

const SUCCESS_MESSAGE = {
  title: 'Congratulations',
  message: 'Your new password will be sent to your email address.',
  buttonText: 'Retry sign in',
};

const ForgottenPasswordForm: React.FC<RouteComponentProps> = () => {
  const [submitError, setSubmitError] = useState('');
  const [formIsPosted, setFormIsPosted] = useState(false);

  const initialValues: ForgottenPasswordPost = {
    emailAddress: '',
  };

  const handleSubmitForm = async (values: ForgottenPasswordPost) => {
    setSubmitError('');

    PostForgottenPassword(values).then((response) => {
      if (!response.errors) {
        setFormIsPosted(true);
        setSubmitError('');
      } else {
        setFormIsPosted(false);
        setSubmitError('Request failed, please try again');
      }
    });
  };

  const validationSchema = Yup.object({
    emailAddress: Yup.string()
      .required('An email address is required')
      .email('Must be a valid email address'),
  });

  return (
    <div className="Form">
      {!formIsPosted ? (
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmitForm}
          validationSchema={validationSchema}
        >
          {({ isSubmitting }) => (
            <Form>
              <h1>Forgotten Password</h1>
              <p className="SubTitle">Enter your e-mail below</p>
              <div className="UserCredentialsSection">
                <FormTextField
                  field={'emailAddress'}
                  label={'Email address'}
                  required={true}
                />
              </div>
              {submitError && <div className="GeneralError">{submitError}</div>}
              <button
                className="Btn BtnOrange"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <Spinner color={'#ffffff'} />
                ) : (
                  'Request E-mail'
                )}
              </button>
            </Form>
          )}
        </Formik>
      ) : (
        <div className="Success">
          <div className="ConfirmationBoxContainer">
            <ConfirmationBox
              {...SUCCESS_MESSAGE}
              buttonOnClick={() => navigate(AppPath.SIGN_IN)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgottenPasswordForm;
